import React from "react";
import Button from "../../../../shared/ui/inputs/classicButton.js";
import "./style.css";
export default function CollectionTabs(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { version: "alternative", text: "Strona g\u0142\u00F3wna", classNames: "nav-collection-tab-button", isActive: props.openedCategory === -1, onClick: () => props.onCategoryOpen(-1) }),
        props.categories.map((category, index) => (React.createElement(Button, { key: index, text: category.name, isActive: index === props.openedCategory, version: "alternative", classNames: "nav-collection-tab-button", onClick: () => props.onCategoryOpen(index) })))));
}
